import React from 'react';
import PropTypes from 'prop-types';

import DebuggerContent from './shared/DebuggerContent';

export default function DebuggerDrawerOutputContent({ outputEvent }) {
  return <DebuggerContent content={outputEvent} lang="json" emptyMessage="No output event for this row." />;
}

DebuggerDrawerOutputContent.propTypes = {
  outputEvent: PropTypes.string,
};
